import Vue from 'vue'
// import App from './components/vacio.vue'
import App from './App.vue'
import FrontChat from './components/front_chat.vue'
// import router from './router'
import store from './store'

// Vue.component('ChatApp', require('./App.vue').default)

Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/es'
import { Notification, Message } from 'element-ui';
window.Notification = Notification
window.Message = Message
window.msj = function (msj, type) {
  Message({
    message: msj,
    type: type
  })
}
Vue.use(ElementUI, { locale })


import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)

const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), { moment });
window.moment = moment

console.log(window.key)
if (window.key !== 'front') {

  new Vue({
    store,
    render: h => h(App)
  }).$mount('#app')
} else {
  new Vue({
    store,
    render: h => h(FrontChat)
  }).$mount('#front-app')

}


// const app = new Vue({
//   store
// }).$mount('#app');
